var map = {
	"./alerts_blue.svg": "d603",
	"./calendar_blue.svg": "e5d5",
	"./conflict_blue.svg": "c794",
	"./crime_blue.svg": "37e4",
	"./disasters_blue.svg": "af42",
	"./elections_blue.svg": "0c63",
	"./events_blue.svg": "e406",
	"./health_blue.svg": "3e20",
	"./layers_blue.svg": "c3ad",
	"./media_blue.svg": "98f8",
	"./places2_blue.svg": "046b",
	"./places_blue.svg": "f51d",
	"./political_terrorism_blue.svg": "56dc",
	"./profile_blue.svg": "99c1",
	"./pulse_blue.svg": "1eb7",
	"./terrorism_blue.svg": "e807",
	"./transportation_blue.svg": "bda3",
	"./travel_blue.svg": "0569",
	"./unrest_blue.svg": "6526",
	"./war_blue.svg": "6f0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2007";